import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Home } from './pages/home';
import { SnackbarProvider } from './components/snackbar/snackbar';

function App() {
  return (
      <>
        <SnackbarProvider>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </SnackbarProvider>
      </>
  );
}

export default App;